import React from "react";

function SpinnerLoader() {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-border m-2" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default SpinnerLoader;
